import i18n from '@i18next/i18n';

const shortcutKeyBindings = [
    {
        typeName: i18n.t('操作'),
        keybindings: [
            {
                description: i18n.t('复制'),
                kbOpts: {
                    win: [
                        'Ctrl', 'C',
                    ],
                    mac: [
                        '⌘', 'C',
                    ],
                },
            },
            {
                description: i18n.t('粘贴'),
                kbOpts: {
                    win: [
                        'Ctrl', 'V',
                    ],
                    mac: [
                        '⌘', 'V',
                    ],
                },
            },
            {
                description: i18n.t('剪切'),
                kbOpts: {
                    win: [
                        'Ctrl', 'X',
                    ],
                    mac: [
                        '⌘', 'X',
                    ],
                },
            },
            {
                description: i18n.t('撤销'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Z',
                    ],
                    mac: [
                        '⌘', 'Z',
                    ],
                },
            },
            {
                description: i18n.t('重做'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Y',
                    ],
                    mac: [
                        '⌘', 'Y',
                    ],
                },
            },
            {
                description: i18n.t('快速复制选中对象'),
                kbOpts: {
                    win: [
                        'Ctrl', i18n.t('鼠标拖动'),
                    ],
                    mac: [
                        '⌘', i18n.t('鼠标拖动'),
                    ],
                },
            },
            {
                description: i18n.t('复制选中对象，并水平移动'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Shift', i18n.t('鼠标拖动'),
                    ],
                    mac: [
                        '⌘', '⇧', i18n.t('鼠标拖动'),
                    ],
                },
            },
            {
                description: i18n.t('复制选中对象，并垂直移动'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Shift', i18n.t('鼠标拖动'),
                    ],
                    mac: [
                        '⌘', '⇧', i18n.t('鼠标拖动'),
                    ],
                },
            },
            {
                description: i18n.t('显示或隐藏参考线'),
                kbOpts: {
                    win: [
                        'Alt', 'F9',
                    ],
                    mac: [
                        '⌃', '⌥', '⌘', 'G',
                    ],
                },
            },
            {
                description: i18n.t('显示或隐藏网格线'),
                kbOpts: {
                    win: [
                        'Shift', 'F9',
                    ],
                    mac: [
                        '⌘', '\'',
                    ],
                },
            },
            {
                description: i18n.t('批注'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Alt', 'M',
                    ],
                    mac: [
                        '⌥', '⌘', 'M',
                    ],
                },
            },
        ],
    },
    {
        typeName: i18n.t('格式'),
        keybindings: [
            {
                description: i18n.t('加粗'),
                kbOpts: {
                    win: [
                        'Ctrl', 'B',
                    ],
                    mac: [
                        '⌘', 'B',
                    ],
                },
            },
            {
                description: i18n.t('斜体'),
                kbOpts: {
                    win: [
                        'Ctrl', 'I',
                    ],
                    mac: [
                        '⌘', 'I',
                    ],
                },
            },
            {
                description: i18n.t('下划线'),
                kbOpts: {
                    win: [
                        'Ctrl', 'U',
                    ],
                    mac: [
                        '⌘', 'U',
                    ],
                },
            },
            {
                description: i18n.t('删除线'),
                kbOpts: {
                    win: [
                        'Ctrl', 'D',
                    ],
                    mac: [
                        '⌘', 'D',
                    ],
                },
            },
        ],
    },
    {
        typeName: i18n.t('导航'),
        keybindings: [
            {
                description: i18n.t('移至左一个字符'),
                kbOpts: {
                    win: [
                        '←',
                    ],
                    mac: [
                        '←',
                    ],
                },
            },
            {
                description: i18n.t('移至右一个字符'),
                kbOpts: {
                    win: [
                        '→',
                    ],
                    mac: [
                        '→',
                    ],
                },
            },
            {
                description: i18n.t('移至上一行'),
                kbOpts: {
                    win: [
                        '↑',
                    ],
                    mac: [
                        '↑',
                    ],
                },
            },
            {
                description: i18n.t('移至下一行'),
                kbOpts: {
                    win: [
                        '↓',
                    ],
                    mac: [
                        '↓',
                    ],
                },
            },
            {
                description: i18n.t('移至左一个词'),
                kbOpts: {
                    win: [
                        'Ctrl', '←',
                    ],
                    mac: [
                        '⌥', '←',
                    ],
                },
            },
            {
                description: i18n.t('移至右一个词'),
                kbOpts: {
                    win: [
                        'Ctrl', '→',
                    ],
                    mac: [
                        '⌥', '→',
                    ],
                },
            },
            {
                description: i18n.t('移至段首'),
                kbOpts: {
                    win: [
                        'Ctrl', '↑',
                    ],
                    mac: [
                        '⌥', '↑',
                    ],
                },
            },
            {
                description: i18n.t('移至段尾'),
                kbOpts: {
                    win: [
                        'Ctrl', '↓',
                    ],
                    mac: [
                        '⌥', '↓',
                    ],
                },
            },
            {
                description: i18n.t('移至行首'),
                kbOpts: {
                    win: [
                        'Home',
                    ],
                    mac: [
                        '⌘', '←',
                    ],
                },
            },
            {
                description: i18n.t('移至行尾'),
                kbOpts: {
                    win: [
                        'End',
                    ],
                    mac: [
                        '⌘', '→',
                    ],
                },
            },
            {
                description: i18n.t('移至编辑对象的首'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Home',
                    ],
                    mac: [
                        '⌘', '↑',
                    ],
                },
            },
            {
                description: i18n.t('移至编辑对象的尾'),
                kbOpts: {
                    win: [
                        'Ctrl', 'End',
                    ],
                    mac: [
                        '⌘', '↓',
                    ],
                },
            },
        ],
    },
    {
        typeName: i18n.t('选择'),
        keybindings: [
            {
                description: i18n.t('全选'),
                kbOpts: {
                    win: [
                        'Ctrl', 'A',
                    ],
                    mac: [
                        '⌘', 'A',
                    ],
                },
            },
            {
                description: i18n.t('向左选择一个字符'),
                kbOpts: {
                    win: [
                        'Shift', '←',
                    ],
                    mac: [
                        '⇧', '←',
                    ],
                },
            },
            {
                description: i18n.t('向右选择一个字符'),
                kbOpts: {
                    win: [
                        'Shift', '→',
                    ],
                    mac: [
                        '⇧', '→',
                    ],
                },
            },
            {
                description: i18n.t('选择光标到上一行'),
                kbOpts: {
                    win: [
                        'Shift', '↑',
                    ],
                    mac: [
                        '⇧', '↑',
                    ],
                },
            },
            {
                description: i18n.t('选择光标到下一行'),
                kbOpts: {
                    win: [
                        'Shift', '↓',
                    ],
                    mac: [
                        '⇧', '↓',
                    ],
                },
            },
            {
                description: i18n.t('选择文本到行首'),
                kbOpts: {
                    win: [
                        'Shift', 'Home',
                    ],
                    mac: [
                        '⇧', '⌘', '←',
                    ],
                },
            },
            {
                description: i18n.t('选择文本到行尾'),
                kbOpts: {
                    win: [
                        'Shift', 'End',
                    ],
                    mac: [
                        '⇧', '⌘', '→',
                    ],
                },
            },
            {
                description: i18n.t('选择文本，从当前光标到编辑对象的首'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Shift', 'Home',
                    ],
                    mac: [
                        '⇧', '⌘', '↑',
                    ],
                },
            },
            {
                description: i18n.t('选择文本，从当前光标到编辑对象的尾'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Shift', 'End',
                    ],
                    mac: [
                        '⇧', '⌘', '↓',
                    ],
                },
            },
            {
                description: i18n.t('选择文本，从当前光标到左一个词'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Shift', '←',
                    ],
                    mac: [
                        '⇧', '⌥', '←',
                    ],
                },
            },
            {
                description: i18n.t('选择文本，从当前光标到右一个词'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Shift', '→',
                    ],
                    mac: [
                        '⇧', '⌥', '→',
                    ],
                },
            },
            {
                description: i18n.t('选择文本，从当前光标到段首'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Shift', '↑',
                    ],
                    mac: [
                        '⇧', '⌥', '↑',
                    ],
                },
            },
            {
                description: i18n.t('选择文本，从当前光标到段尾'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Shift', '↓',
                    ],
                    mac: [
                        '⇧', '⌥', '↓',
                    ],
                },
            },
        ],
    },
    {
        typeName: i18n.t('查看'),
        keybindings: [
            {
                description: i18n.t('放大视图'),
                kbOpts: {
                    win: [
                        'Ctrl', i18n.t('滚轮'), '+',
                    ],
                    mac: [
                        '⌘', i18n.t('滚轮'), '+',
                    ],
                },
            },
            {
                description: i18n.t('缩小视图'),
                kbOpts: {
                    win: [
                        'Ctrl', i18n.t('滚轮'), '-',
                    ],
                    mac: [
                        '⌘', i18n.t('滚轮'), '-',
                    ],
                },
            },
            {
                description: i18n.t('回到100%'),
                kbOpts: {
                    win: [
                        'Ctrl', '0',
                    ],
                    mac: [
                        '⌘', '0',
                    ],
                },
            },
            {
                description: i18n.t('开始播放'),
                kbOpts: {
                    win: [
                        'Ctrl', 'Enter',
                    ],
                    mac: [
                        '⌘', 'Enter',
                    ],
                },
            },
            {
                description: i18n.t('结束放映'),
                kbOpts: {
                    win: [
                        'Esc',
                    ],
                    mac: [
                        'Esc',
                    ],
                },
            },
            {
                description: i18n.t('查找'),
                kbOpts: {
                    win: [
                        'Ctrl', 'F',
                    ],
                    mac: [
                        '⌘', 'F',
                    ],
                },
            },
            {
                description: i18n.t('替换'),
                kbOpts: {
                    win: [
                        'Ctrl', 'H',
                    ],
                    mac: [
                        '⌘', 'H',
                    ],
                },
            },
            {
                description: i18n.t('打开快捷键右侧栏'),
                kbOpts: {
                    win: [
                        'Ctrl', '/',
                    ],
                    mac: [
                        '⌘', '/',
                    ],
                },
            },
        ],
    },
];
export default shortcutKeyBindings;
